import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { EngineeringService } from 'src/app/services/engineering/engineering.service';

@Component({
  selector: 'app-submdrawingsadmin',
  templateUrl: './submdrawingsadmin.component.html',
  styleUrls: ['./submdrawingsadmin.component.css']
})
export class SubmdrawingsadminComponent implements OnInit {

  data: any;

  constructor(private engineeringServices : EngineeringService, private router : Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.getAllSubmittedDrawings();
  }

  getAllSubmittedDrawings() {
    this.engineeringServices.GetAllSubmittedDrawings().subscribe(
      data => {
        this.data = data;
        console.log(this.data);
      }
    )
  }

  submitQuery = function (id) {
    //alert(id);
    this.router.navigate(['/drawcomments/' + id + '']);
  }
  searchsubdrawingasadmin(keyword){
    this.engineeringServices.searchsubdrawing(keyword).subscribe(
      (data) => {
        this.data=data;
        console.log(data);
      }
    )
  }

}
